import { getCalendarGroups } from './getCalendarGroups';

export function findCalendarGroup(groupId: string, userIdentity: string) {
    const filteredGroups = getCalendarGroups().filter(
        group =>
            group.serverGroupId == groupId &&
            group.calendarGroupId.mailboxInfo.userIdentity == userIdentity
    );
    return filteredGroups.length > 0 ? filteredGroups[0] : null;
}
